import { IconButton, Image, Stack, StackDivider, StackProps } from "@chakra-ui/react";
import { FaFolder, FaUsers } from "react-icons/fa";
import Logo from '../../assets/images/logo.png'
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { IoMdExit } from "react-icons/io";
import { Link as ReactLink } from 'react-router-dom';

export default function PracticeSidebar(props: StackProps) {
    return (
        <Stack
            w={'6vw'}
            transition={'width 1s'}
            p={4}
            overflowY={'hidden'}
            {...props}
            spacing={6}
            divider={<StackDivider />}
            justify={"center"}
            align={"center"}
            boxShadow={'0px 0px 6px 0px rgba(0,0,0,0.2)'}
            overflowX={'hidden'}
            bg={'#5E5E5E'}
        >
            <Stack
                w={'full'}
                justify={'center'}
                align={"center"}
                spacing={4}
            >
                <Image
                    src={Logo}
                    w={'100%'}
                    draggable={'false'}
                    rounded={'full'}
                    transition={'width 1s'}
                />
            </Stack>
            <Stack h={'full'} py={2} overflowY={'hidden'}>
                <IconButton
                    aria-label="Practice Dashboard"
                    icon={<BsFillGrid3X3GapFill transform="scale(2)" />}
                    w={'72.5px'}
                    h={'70px'}
                    rounded={'none'}
                    bg={'rgba(0,0,0,0.1)'}
                    color={'white'}
                    _hover={{ bg: 'rgba(0,0,0,0.2)' }}
                    _active={{ bg: 'rgba(0,0,0,0.4)' }}
                    as={ReactLink}
                    to={'/practice/dashboard'}
                />

                <IconButton
                    aria-label="Practice Staff"
                    icon={<FaUsers transform="scale(2)" />}
                    w={'72.5px'}
                    h={'70px'}
                    rounded={'none'}
                    bg={'rgba(0,0,0,0.1)'}
                    color={'white'}
                    _hover={{ bg: 'rgba(0,0,0,0.2)' }}
                    _active={{ bg: 'rgba(0,0,0,0.4)' }}
                    as={ReactLink}
                    to={'/practice/staff'}
                />

                <IconButton
                    aria-label="Practice Profile"
                    icon={<FaFolder transform="scale(2)" />}
                    w={'72.5px'}
                    h={'70px'}
                    rounded={'none'}
                    bg={'rgba(0,0,0,0.1)'}
                    color={'white'}
                    _hover={{ bg: 'rgba(0,0,0,0.2)' }}
                    _active={{ bg: 'rgba(0,0,0,0.4)' }}
                    as={ReactLink}
                    to={'/practice/profile'}
                />

                <IconButton
                    aria-label="Exit Practice Mode"
                    icon={<IoMdExit transform="scale(2)" />}
                    w={'72.5px'}
                    h={'70px'}
                    rounded={'none'}
                    bg={'rgba(0,0,0,0.1)'}
                    color={'white'}
                    _hover={{ bg: 'rgba(0,0,0,0.2)' }}
                    as={ReactLink}
                    to={'/dashboard'}
                />
            </Stack>
        </Stack>
    )
}